import { memo, FC, HTMLAttributes, useMemo } from 'react';
import cn from 'classnames';
import loadable from '@loadable/component';

import { WikiArticleData } from '@Types/Wiki';
import styles from './RecommendedArticles.module.css';
import MainArticle from '../MainArticle';
import { RoomTourTextData } from '@Pages/PageWikiRubric/typings';
import WikiArticle from '@Components/WikiArticle';

const RoomTourBanner = loadable(() => import('../RoomTourBanner'));

export interface RecommendedArticlesProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  articles: (WikiArticleData | RoomTourTextData)[];
}

const RecommendedArticles: FC<RecommendedArticlesProps> = (props) => {
  const { className, articles, children, ...restProps } = props;

  const mainArticle = useMemo(
    () => articles.find((article: WikiArticleData) => article.main),
    [articles],
  );

  const anotherRecommended = useMemo(() => {
    return articles.filter((article: WikiArticleData) => !article.main);
  }, [articles]);

  return (
    <div {...restProps} className={cn(className)}>
      {mainArticle && (
        <MainArticle article={mainArticle as WikiArticleData} className={styles.mainArticle} />
      )}

      {children}

      {anotherRecommended && anotherRecommended.length > 0 && (
        <div className={styles.wrapper}>
          {anotherRecommended.map((article) => {
            if ((article as RoomTourTextData).shareBlock) {
              const roomTour = article as RoomTourTextData;
              return (
                <RoomTourBanner
                  key={roomTour.shareBlock.link}
                  content={roomTour.shareBlock}
                  className={styles.roomTourBanner}
                />
              );
            }
            const wikiArticle = article as WikiArticleData;
            return <WikiArticle key={wikiArticle.id} article={wikiArticle} />;
          })}
        </div>
      )}
    </div>
  );
};

export default memo(RecommendedArticles);
